// extracted by mini-css-extract-plugin
module.exports = {"footerHeight":"50px","footer-bar":"footer-bar__footer-bar___3w4SR","footer-bar--bordered":"footer-bar__footer-bar--bordered___gfmsn footer-bar__footer-bar___3w4SR"};